import { type MatterLostWageSchema } from "@/lib/data/schemas/matters/MatterSchema";
import { isNil } from "lodash";
import { type z } from "zod";

export const calculateLostWages = (
  positionType: z.infer<typeof MatterLostWageSchema.shape.positionType>,
  positionRate: z.infer<typeof MatterLostWageSchema.shape.positionRate>,
  timeMissed: z.infer<typeof MatterLostWageSchema.shape.timeMissed>,
  timeMissedUnit: "hours" | "days" = "days",
) => {
  if (isNil(positionRate) || isNil(timeMissed)) {
    return 0;
  }

  const normalizedPositionRate = Number(positionRate);
  const normalizedTimeMissed = Number(timeMissed);
  if (
    !Number.isFinite(normalizedPositionRate) ||
    !Number.isFinite(normalizedTimeMissed)
  ) {
    return 0;
  }

  const totalLostAmount =
    positionType === "Hourly"
      ? normalizedPositionRate * normalizedTimeMissed
      : (normalizedPositionRate / 52 / 40) * normalizedTimeMissed;
  if (timeMissedUnit === "hours") {
    return Number.isFinite(totalLostAmount) ? totalLostAmount : 0;
  }
  const totalLostWages = totalLostAmount * 8;
  return Number.isFinite(totalLostWages) ? totalLostWages : 0;
};
